import { createContext, type ReactNode, useContext, useState } from 'react';

interface MenuContextType {
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
  invert: boolean;
  setInvert: (invert: boolean) => void;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const MenuProvider = ({ children }: { children: ReactNode }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [invert, setInvert] = useState(false);
  return <MenuContext.Provider value={{ menuOpen, setMenuOpen, invert, setInvert }}>{children}</MenuContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenuContext must be used within a MenuProvider');
  }
  return context;
};
